import { render, staticRenderFns } from "./JsonEditModal.vue?vue&type=template&id=2c9fd0dc&scoped=true&"
import script from "./JsonEditModal.vue?vue&type=script&lang=js&"
export * from "./JsonEditModal.vue?vue&type=script&lang=js&"
import style0 from "./JsonEditModal.vue?vue&type=style&index=0&id=2c9fd0dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9fd0dc",
  null
  
)

export default component.exports